import { getBrandName } from '../../../../Utils/helper';
import { CertName } from './styled';

export default function index(props) {
  const { productId, isFertilityProduct, certName } = props;

  const getProductCategory = () => {
    return getBrandName(productId);
  };

  return (
    <>
      {getProductCategory() ? (
        <CertName hideSection={isFertilityProduct}>
          {certName || getProductCategory()}
        </CertName>
      ) : null}
    </>
  );
}
